import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton, Tooltip, Grid } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import { withRouter } from 'react-router-dom';
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers';
import PageHeader from 'main/components/PageHeader';
import TableFilter from 'main/components/tableFilter/TableFilter';
import * as TableFilterActions from 'main/components/tableFilter/store/actions';

const styles = theme => ({
	layoutRoot: {},
});

class LessonList extends Component {

	constructor(props) {
		super(props);
		this.props.getLessonList(props.auth.user.data.auth_id, 'list');
	};

	componentWillUnmount = () => {
		this.props.setTableFilter(this.props.auth.user.data.auth_id, 'LessonList', this.props.filterList.filterColumns);
		this.props.clearFilterStore();
	};

	checkLockPermission = (row) => {
		const auth_id = this.props.auth.user.data.auth_id;
		const role = this.props.auth.user.role;
		if (row.IsLocked === 0) {
			return true
		}
		else {
			if (role === 'dev' || role === 'admin' || role === 'company') {
				return true
			}
			else if (role === 'instructor' && row.LockedByAuthID === auth_id) {
				return true
			}
		}
		return false
	}

	editAllow = (row) => {
		if (this.checkLockPermission(row)) {
			let tooltipContent = 'Edit';
			if (row.IsLocked === 1) {
				tooltipContent = <React.Fragment><div>Edit</div><div>(Locked)</div></React.Fragment>
			}
			return (
				<Tooltip title={tooltipContent}>
					<IconButton
						style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
						onClick={(ev) => {
							ev.stopPropagation();
							this.handleRowClick('edit', row.lesson_id);
						}}
					>
						<Icon>border_color</Icon>
					</IconButton>
				</Tooltip>
			)
		}
		else {
			return (
				<Tooltip title="This lesson is locked">
					<Icon style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }} >lock</Icon>
				</Tooltip>
			)
		}

	}

	handleRowClick(page_type, lesson_id) {
		this.props.history.push(`/lesson/${page_type}/${lesson_id}`);
	};

	checkFilterValueSaved = (column) => {
		const { table_filter } = this.props
		if (!table_filter['LessonList']) {
			return false
		}
		if (!table_filter['LessonList'].find(col => col.id === column)) {
			return false
		}

		else {
			return table_filter['LessonList'].find(col => col.id === column).value.filterValue
		}
	}

	getTrProps = (state, rowInfo, instance) => {
        if (rowInfo) {
            if (rowInfo.original.Active === 0) {
                return {
                    style: {
                        background: '#a85e59'
                    } 
                }
            }
        }
        return {};
    }

	render() {
		const { classes, lessonList, table_sort, table_filter, table_page_size, is_loaded } = this.props;
		const table_name = this.constructor.name;
		if (!is_loaded || !this.props.lessonListLoadedAfterSave || !this.props.listLoaded) return <React.Fragment>Loading...</React.Fragment>;

		return (
			<FusePageCarded
				classes={{
					root: classes.layoutRoot
				}}
				header={
					<PageHeader
						component_type={"lesson"}
						view_type={"list"}
					/>
				}
				contentToolbar={
					<div className="px-24 flex flex-1 justify-end">
						<TabPanelButtons
							component_name={"lesson"}
							view_type={"list"}
							button_list={[
								{
									display: "Add",
									type: "create",
									color: "primary",
									onClick: () => this.props.history.push("/lesson/create"),
								}
							]}
						/>
					</div>
				}
				content={
					<Grid container style={{ height: '100%' }}>
						<Grid item xs={9}>
							<div style={{ position: 'relative', height: '100%', width: '100%' }}>
								<ReactTable
									style={{ position: 'absolute' }}
									columns={[
										{
											Header: "Lesson Name",
											accessor: "LessonName",
											Cell: row => (
												<TableCellTooltip
													item={row.original.LessonName}
													chars={20}
												/>
											)
										},
										{
											Header: "Lesson Description",
											accessor: "LessonDescription",
											Cell: row => (
												<TableCellTooltip
													item={row.original.LessonDescription}
													chars={20}
												/>
											)
										},
										{
											Header: "Unscheduled",
											id: "Unscheduled",
											accessor: a => a.Unscheduled === 1 ? <Icon style={{ marginLeft: 'auto', marginRight: 'auto' }}>check</Icon> : null,
											maxWidth: 100,
										},
										{
											Header: "Actions",
											maxWidth: 100,
											Cell: row => (
												<div className="flex items-center">
													<Tooltip title="Detail">
														<IconButton
															style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
															onClick={(ev) => {
																ev.stopPropagation();
																this.handleRowClick('detail', row.original.lesson_id);
															}}
														>
															<Icon>library_books</Icon>
														</IconButton>
													</Tooltip>
													{!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "lesson", "edit") ? null :
														this.editAllow(row.original)
													}
												</div>
											)
										}
									]}
									data={this.props.filterList.filteredDataList}
									defaultPageSize={25}
									pageSize={table_page_size[table_name]}
									className="-striped -highlight"
									noDataText="No Lessons Found"
									defaultSorted={table_sort[table_name]}
									onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
									filterable={false}
									getTrProps={this.getTrProps}
									defaultFiltered={table_filter[table_name]}
									onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
								/>
							</div>
						</Grid>
						<Grid item xs={3} style={{ overflowY: 'auto', overflowX: 'hidden' }}>
							<div style={{ position: 'relative', height: '100%', width: '100%' }}>
								<TableFilter
									componentName={'LessonList'}
									defaultList={lessonList}
									preloadValues={table_filter['LessonList'] ? true : false}
									columns={[
										{
											columnName: 'Lesson Name',
											column_id: 'LessonName',
											columnType: 'string',
											filterType: 'string_contains',
											value: this.checkFilterValueSaved('LessonName') || '',
											active: this.checkFilterValueSaved('LessonName') ? true : false
										},
										{
											columnName: 'Lesson Description',
											column_id: 'LessonDescription',
											columnType: 'string',
											filterType: 'string_contains',
											value: this.checkFilterValueSaved('LessonDescription') || '',
											active: this.checkFilterValueSaved('LessonDescription') ? true : false
										},
										{
                                            columnName: 'Active',
                                            column_id: 'Active',
                                            columnType: 'binary_switch',
                                            filterType: 'binary_switch',
                                            // 0 off, 1 false, 2 true
                                            value: this.checkFilterValueSaved('Active') ? Number(this.checkFilterValueSaved('Active')) : 2,
                                            active: true
                                        },
										{
											columnName: 'Unscheduled',
											column_id: 'Unscheduled',
											columnType: 'binary_switch',
											filterType: 'binary_switch',
											// 0 off, 1 false, 2 true
											value: Number(this.checkFilterValueSaved('Unscheduled')),
											active: Number(this.checkFilterValueSaved('Unscheduled')) !== 0
										},
										{
											columnName: 'Tags',
											column_id: 'Labels',
											columnType: 'array',
											filterType: 'array_search',
											searchableValues: this.props.lessonListSearchable.labels,
											switchVal: false,
											value: this.checkFilterValueSaved('Labels'),
											active: this.checkFilterValueSaved('Labels').length > 0
										},
										{
											columnName: 'Companies',
											column_id: 'Companies',
											columnType: 'array',
											filterType: 'array_search',
											searchableValues: this.props.lessonListSearchable.companies,
											switchVal: false,
											value: this.checkFilterValueSaved('Companies'),
											active: this.checkFilterValueSaved('Companies').length > 0
										},
									]}
								/>
							</div>

						</Grid>
					</Grid>

				}
			/>
		);
	}


}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		getLessonList: Actions.getLessonList,
		setTableSort: TableActions.setTableSort,
		setTableFilter: TableActions.setTableFilter,
		setTablePageSize: TableActions.setTablePageSize,
		clearFilterStore: TableFilterActions.clearFilterStore,
		setTableFilter: TableFilterActions.saveTableFilter,
	}, dispatch);
}

function mapStateToProps({ lessonApp, auth, tableSort, tableFilter }) {
	return {
		lessonList: lessonApp.lessons.lessonList,
		listLoaded: lessonApp.lessons.listLoaded,
		table_sort: tableSort.table_sort,
		table_filter: tableSort.table_filter,
		table_page_size: tableSort.table_page_size,
		is_loaded: tableSort.is_loaded,
		lessonListLoadedAfterSave: lessonApp.lessons.lessonListLoadedAfterSave,
		lessonListSearchable: lessonApp.lessons.lessonListSearchable,
		filterList: tableFilter,
		auth,
	}
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(LessonList)));


// WEBPACK FOOTER //
// src/main/content/lesson/LessonList.js